import React from 'react';
import { brandName, contactDetails } from '../content/siteContent';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <p>&copy; {year} {brandName}. All rights reserved.</p>
        <p>
          <a href={contactDetails.phoneHref}>{contactDetails.phoneDisplay}</a>
          {' · '}
          <a href={contactDetails.emailHref}>{contactDetails.email}</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
